import { MRT_ColumnDef } from "material-react-table";
import { Link, Stack, Typography } from "@mui/material";
import { CompanyWithSuspectedMatch, ContactWithSuspectedMatch } from "../../phonebook/types";
import NavigationIconButton from "./NavigateIcon";


export const companySuspectedMatchesColumns: MRT_ColumnDef<CompanyWithSuspectedMatch>[] = [
  {
    header: "Date/Time Created",
    accessorKey: "createdDate",
    accessorFn: (row) => {
      return new Date(row.createdDate).toLocaleDateString();
    },
    muiTableHeadCellProps: {
      sx: {
        width: 130,
        minWidth: 130,
        maxWidth: 130,
      },
    },
    muiTableBodyCellProps: {
      sx: {
        verticalAlign: "top",
        width: 130,
        minWidth: 130,
        maxWidth: 130,
      },
    },
  },
  
  {
    header: "Company Name",
    accessorFn: (row) => {
      return (
        <Stack direction={"row"}>
          <Link target="_blank" rel="noreferrer" href={`/phonebook/company/profile?id=${row.id}`}>
            <Typography variant="body2">{row.name || ""}</Typography>
          </Link>
        </Stack>
      );
    },
    muiTableBodyCellProps: {
      sx: {
        verticalAlign: "top"
      }
    }
  },
  {
    header: "User",
    accessorKey: "username",
    id: "username",
    muiTableBodyCellProps: {
      sx: {
        verticalAlign: "top"
      }
    },
    muiFilterTextFieldProps: {
      variant: "outlined",
      size: "small"
    }
  },
  {
    id: "companySuspectedMatches",
    header: "Suspected Duplicates",
    accessorFn: (row) => {
      return row?.suspectedMatches?.map((s) => {
        return (
        <Stack direction={"row"}>
          <Link target="_blank" rel="noreferrer" href={`/phonebook/company/profile?id=${s.company?.id}`}>
            <Typography variant="body2" color="error">
              {s.company.name || ""}
            </Typography>
          </Link>
        </Stack>
      )});
    },
    muiTableBodyCellProps: {
      sx: {
        verticalAlign: "top"
      }
    }
  },
  {
    id: "matchingField",
    header: "Matching Field",
    accessorFn: (row) => {
      return row?.suspectedMatches?.map((s) => (
        <Typography variant="body2" color="error">
          {s.matchedOnWebsite && "Website "}
          {s.matchedOnName && "Name "}
          {s.matchedOnPhoneNumber && "Phone"}

          <NavigationIconButton
            to={`../phonebook/companiesMerge?ids=${row.id}&ids=${s.company.id}`}
            openInNewTab={true}
            aria-label="Merge Contacts"
          />
        </Typography>
      ));
    }
  }
];
